import React from 'react';
import { IconButton, Button } from '@material-ui/core'
import ProcedureManualIcon from '@material-ui/icons/ListAlt';
import styled from 'styled-components';
import ActionsContextV2 from '../ActionsContextV2';


const ProcedureManualCheckedButton = styled.img`
height:42px;
width:40px;
`;



const ActionProcedureManualButtonV2 = ({ functionId, projectId, pendingActions, approvedActions, readOnly }) => {
    const context = React.useContext(ActionsContextV2)

    const renderProcedureManualIcon = () => (
        <IconButton onClick={() => context.showProcedureManual({ functionId, projectId, readOnly })}>
            <ProcedureManualIcon style={{ width: 38, height: 45 }} />
        </IconButton>
    );


    const renderProcedureManualIconWithBadge = () => (
        <Button onClick={() => context.showProcedureManual({ functionId, projectId, readOnly })}>
            <ProcedureManualCheckedButton src={"./icons/procedureManualChecked.png"} />
        </Button>
    );

    const renderProcedureManualIconWithIncompleteBadge = () => (
        <Button onClick={() => context.showProcedureManual({ functionId, projectId, readOnly })}>
            <ProcedureManualCheckedButton src={"./icons/procedureManualPending.png"} />
        </Button>
    );

    // const countType = (type) => {
    //     const countTypes = approvedActions.filter(item => item.status === type);
    //     return countTypes.length;
    // }

    if (pendingActions.length && approvedActions.length) {
        return renderProcedureManualIconWithIncompleteBadge();
    } else if (approvedActions.length && !pendingActions.length) {
        return renderProcedureManualIconWithBadge();
    } else {
        return renderProcedureManualIcon();
    }
}

export default ActionProcedureManualButtonV2;